import {getDeviceType, getSiteId} from '../../helpers'
import {getSegmentReady} from '../config'
import {learningCenterEventNames} from './constants'

const eventNamesTypeMap = {
    [learningCenterEventNames.goalProgressStatus]: 'goal',
    [learningCenterEventNames.levelProgressStatus]: 'level',
    [learningCenterEventNames.moduleProgressStatus]: 'module',
    [learningCenterEventNames.lessonProgressStatus]: 'lesson'
}

const trackItemOpened = async ({eventType, id, openedTimestamp}) => {
    const segmentAnalytics = await getSegmentReady()
    if (!segmentAnalytics) return
    const type = eventNamesTypeMap[eventType]
    segmentAnalytics.track(eventType, {
        [`${type}Name`]: id,
        [`${type}Opened`]: 'Yes',
        [`${type}OpenedTimestamp`]: openedTimestamp,
        device: getDeviceType(),
        sales_channel: getSiteId()
    })
}
const trackItemStarted = async ({eventType, id, startedTimestamp}) => {
    const segmentAnalytics = await getSegmentReady()
    if (!segmentAnalytics) return
    const type = eventNamesTypeMap[eventType]
    segmentAnalytics.track(eventType, {
        [`${type}Name`]: id,
        [`${type}Started`]: 'Yes',
        [`${type}StartedTimestamp`]: startedTimestamp,
        device: getDeviceType(),
        sales_channel: getSiteId()
    })
}

const trackItemCompleted = async ({eventType, id, completedTimestamp}) => {
    const segmentAnalytics = await getSegmentReady()
    if (!segmentAnalytics) return
    const type = eventNamesTypeMap[eventType]
    segmentAnalytics.track(eventType, {
        [`${type}Name`]: id,
        [`${type}Completed`]: 'Yes',
        [`${type}CompletedTimestamp`]: completedTimestamp,
        device: getDeviceType(),
        sales_channel: getSiteId()
    })
}
const trackQuizAttempt = async ({quizName, quizResult, attemptTimestamp}) => {
    const segmentAnalytics = await getSegmentReady()
    if (!segmentAnalytics) return
    segmentAnalytics.track(learningCenterEventNames.quizAttemptStatus, {
        quizName,
        quizAttemptResult: quizResult,
        quizAttemptTimestamp: attemptTimestamp,
        device: getDeviceType(),
        sales_channel: getSiteId()
    })
}

export {trackItemStarted, trackItemCompleted, trackItemOpened, trackQuizAttempt}
